import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import Reveal from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function OffersSection({ offers = [], onBook }) {
  const { t, lang } = useLang();

  return (
    <section className="relative py-24 lg:py-40 bg-[#09090b]" data-testid="offers-section">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <Reveal>
            <div className="overline mb-4">{t.offers.overline}</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1] max-w-xl">
              {t.offers.title.split("\n").map((l, i) => (
                <span key={l || `offers-line-${i}`} className="block">{l}</span>
              ))}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-md text-white/70 text-base leading-relaxed">{t.offers.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {offers.slice(0, 3).map((o, i) => {
            const title = lang === "it" ? o.title_it : o.title_en;
            const sub = lang === "it" ? o.subtitle_it : o.subtitle_en;
            const desc = lang === "it" ? o.description_it : o.description_en;
            const cta = lang === "it" ? o.cta_it : o.cta_en;
            return (
              <Reveal key={o.id} delay={i * 0.1}>
                <div className="card-hover group relative overflow-hidden border border-white/10 hover:border-[#C5A059]/50 transition-colors" data-testid={`offer-card-${o.id}`}>
                  <div className="relative aspect-[4/3] overflow-hidden bg-[#18181b]">
                    <img src={o.cover} alt={title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20" />
                    <div className="absolute top-5 left-5 bg-[#C5A059] text-black px-3 py-1.5 text-[10px] uppercase tracking-[0.25em] font-medium">{o.discount}</div>
                  </div>
                  <div className="p-7 bg-[#0c0c0e]">
                    <div className="overline mb-2 text-white/60">{sub}</div>
                    <h3 className="font-serif text-3xl mb-3">{title}</h3>
                    <p className="text-white/65 text-sm leading-relaxed">{desc}</p>
                    <button
                      onClick={onBook}
                      data-testid={`offer-cta-${o.id}`}
                      className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#C5A059] hover:gap-3 transition-all"
                    >
                      {cta} <ArrowRight size={14} />
                    </button>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
